import {createContext, useContext} from 'react';

interface VoiceCallFullscreenContextType {
	isVoiceCallFullscreen: boolean;
	setIsVoiceCallFullscreen: (isFullscreen: boolean) => void;
}

export const VoiceCallFullscreenContext = createContext<VoiceCallFullscreenContextType | undefined>(undefined);

export const useVoiceCallFullscreen = () => {
	const context = useContext(VoiceCallFullscreenContext);
	if (context === undefined) {
		throw new Error('useVoiceCallFullscreen must be used within a VoiceCallFullscreenProvider');
	}
	return context;
};
